import BaseAPI from '../BaseAPI';
const baseURL = process.env.GATSBY_SKI_RESORT_API_URL;

class SkiResortAPI extends BaseAPI {
  protected static override _baseURL = baseURL || '';
  protected static override _apiKey = process.env.GATSBY_MODER_FRENDS_APIKEY || '';
}

export default SkiResortAPI;
